import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _83dfe29a = () => interopDefault(import('../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _cbd4fa14 = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _2d668369 = () => interopDefault(import('../pages/account/details/index.vue' /* webpackChunkName: "pages/account/details/index" */))
const _79191b1c = () => interopDefault(import('../pages/account/funds.vue' /* webpackChunkName: "pages/account/funds" */))
const _b527931c = () => interopDefault(import('../pages/account/invoices.vue' /* webpackChunkName: "pages/account/invoices" */))
const _3b227877 = () => interopDefault(import('../pages/account/loyalities.vue' /* webpackChunkName: "pages/account/loyalities" */))
const _0b35c9c5 = () => interopDefault(import('../pages/account/newsletter.vue' /* webpackChunkName: "pages/account/newsletter" */))
const _fa9500f6 = () => interopDefault(import('../pages/account/overview.vue' /* webpackChunkName: "pages/account/overview" */))
const _68df6fb6 = () => interopDefault(import('../pages/account/purchases.vue' /* webpackChunkName: "pages/account/purchases" */))
const _17fc993e = () => interopDefault(import('../pages/account/transactions.vue' /* webpackChunkName: "pages/account/transactions" */))
const _6a297c5e = () => interopDefault(import('../pages/account/wishlist.vue' /* webpackChunkName: "pages/account/wishlist" */))
const _64733f2d = () => interopDefault(import('../pages/account/details/delivery.vue' /* webpackChunkName: "pages/account/details/delivery" */))
const _2952b484 = () => interopDefault(import('../pages/account/details/invoice.vue' /* webpackChunkName: "pages/account/details/invoice" */))
const _11e3b300 = () => interopDefault(import('../pages/account/details/login.vue' /* webpackChunkName: "pages/account/details/login" */))
const _674b5d00 = () => interopDefault(import('../pages/account/details/profile.vue' /* webpackChunkName: "pages/account/details/profile" */))
const _7b3c9810 = () => interopDefault(import('../pages/account/details/store.vue' /* webpackChunkName: "pages/account/details/store" */))
const _adac2e18 = () => interopDefault(import('../pages/product/lister/actie.vue' /* webpackChunkName: "pages/product/lister/actie" */))
const _07b969e6 = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _1cb34a30 = () => interopDefault(import('../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _168b6cb3 = () => interopDefault(import('../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _ba494cba = () => interopDefault(import('../pages/checkout/delivery.vue' /* webpackChunkName: "pages/checkout/delivery" */))
const _9ec73d66 = () => interopDefault(import('../pages/checkout/information.vue' /* webpackChunkName: "pages/checkout/information" */))
const _2060e0a8 = () => interopDefault(import('../pages/checkout/overview.vue' /* webpackChunkName: "pages/checkout/overview" */))
const _34734da7 = () => interopDefault(import('../pages/checkout/payment.vue' /* webpackChunkName: "pages/checkout/payment" */))
const _544616ee = () => interopDefault(import('../pages/checkout-redirect.vue' /* webpackChunkName: "pages/checkout-redirect" */))
const _3547ca66 = () => interopDefault(import('../pages/checkout-success.vue' /* webpackChunkName: "pages/checkout-success" */))
const _635fe0e3 = () => interopDefault(import('../pages/icon.vue' /* webpackChunkName: "pages/icon" */))
const _2542f4d8 = () => interopDefault(import('../pages/blog/category/index.vue' /* webpackChunkName: "pages/blog/category/index" */))
const _cad79e9c = () => interopDefault(import('../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _7c127f50 = () => interopDefault(import('../pages/brand/index.vue' /* webpackChunkName: "pages/brand/index" */))
const _69715966 = () => interopDefault(import('../pages/store/lister/index.vue' /* webpackChunkName: "pages/store/lister/index" */))
const _37296ece = () => interopDefault(import('../pages/forgot-password/index.vue' /* webpackChunkName: "pages/forgot-password/index" */))
const _15468272 = () => interopDefault(import('../pages/wishlist/index.vue' /* webpackChunkName: "pages/wishlist/index" */))
const _78ec3ad2 = () => interopDefault(import('../pages/blocks/demo.vue' /* webpackChunkName: "pages/blocks/demo" */))
const _4028466a = () => interopDefault(import('../pages/forgot-password/reset.vue' /* webpackChunkName: "pages/forgot-password/reset" */))
const _41d65b9f = () => interopDefault(import('../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _d4757a90 = () => interopDefault(import('../pages/login/guest.vue' /* webpackChunkName: "pages/login/guest" */))
const _667a0590 = () => interopDefault(import('../pages/forgot-password/redirect.vue' /* webpackChunkName: "pages/forgot-password/redirect" */))
const _25daf69f = () => interopDefault(import('../pages/blog/detail/_slug.vue' /* webpackChunkName: "pages/blog/detail/_slug" */))
const _f85863ae = () => interopDefault(import('../pages/review/detail/_slug.vue' /* webpackChunkName: "pages/review/detail/_slug" */))
const _ba15b9ec = () => interopDefault(import('../pages/review/writing/_slug.vue' /* webpackChunkName: "pages/review/writing/_slug" */))
const _70ab1f54 = () => interopDefault(import('../pages/product/detail/_slug.vue' /* webpackChunkName: "pages/product/detail/_slug" */))
const _796659b8 = () => interopDefault(import('../pages/store/detail/_slug.vue' /* webpackChunkName: "pages/store/detail/_slug" */))
const _706bc466 = () => interopDefault(import('../pages/search/_slug.vue' /* webpackChunkName: "pages/search/_slug" */))
const _62d218be = () => interopDefault(import('../pages/blog/category/_.vue' /* webpackChunkName: "pages/blog/category/_" */))
const _0ce2f767 = () => interopDefault(import('../pages/blog/tag/_.vue' /* webpackChunkName: "pages/blog/tag/_" */))
const _78772b8d = () => interopDefault(import('../pages/brand/lister/_.vue' /* webpackChunkName: "pages/brand/lister/_" */))
const _7bd086a5 = () => interopDefault(import('../pages/product/lister/_.vue' /* webpackChunkName: "pages/product/lister/_" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _2efaf336 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _83dfe29a,
    children: [{
      path: "",
      component: _cbd4fa14,
      name: "account___nl"
    }, {
      path: "details",
      component: _2d668369,
      name: "account-details___nl"
    }, {
      path: "funds",
      component: _79191b1c,
      name: "account-funds___nl"
    }, {
      path: "invoices",
      component: _b527931c,
      name: "account-invoices___nl"
    }, {
      path: "loyalities",
      component: _3b227877,
      name: "account-loyalities___nl"
    }, {
      path: "newsletter",
      component: _0b35c9c5,
      name: "account-newsletter___nl"
    }, {
      path: "overview",
      component: _fa9500f6,
      name: "account-overview___nl"
    }, {
      path: "purchases",
      component: _68df6fb6,
      name: "account-purchases___nl"
    }, {
      path: "transactions",
      component: _17fc993e,
      name: "account-transactions___nl"
    }, {
      path: "wishlist",
      component: _6a297c5e,
      name: "account-wishlist___nl"
    }, {
      path: "details/delivery",
      component: _64733f2d,
      name: "account-details-delivery___nl"
    }, {
      path: "details/invoice",
      component: _2952b484,
      name: "account-details-invoice___nl"
    }, {
      path: "details/login",
      component: _11e3b300,
      name: "account-details-login___nl"
    }, {
      path: "details/profile",
      component: _674b5d00,
      name: "account-details-profile___nl"
    }, {
      path: "details/store",
      component: _7b3c9810,
      name: "account-details-store___nl"
    }]
  }, {
    path: "/actie",
    component: _adac2e18,
    name: "product-lister-actie___nl"
  }, {
    path: "/cart",
    component: _07b969e6,
    name: "cart___nl"
  }, {
    path: "/checkout",
    component: _1cb34a30,
    children: [{
      path: "",
      component: _168b6cb3,
      name: "checkout___nl"
    }, {
      path: "delivery",
      component: _ba494cba,
      name: "checkout-delivery___nl"
    }, {
      path: "information",
      component: _9ec73d66,
      name: "checkout-information___nl"
    }, {
      path: "overview",
      component: _2060e0a8,
      name: "checkout-overview___nl"
    }, {
      path: "payment",
      component: _34734da7,
      name: "checkout-payment___nl"
    }]
  }, {
    path: "/checkout-redirect",
    component: _544616ee,
    name: "checkout-redirect___nl"
  }, {
    path: "/checkout-success",
    component: _3547ca66,
    name: "checkout-success___nl"
  }, {
    path: "/icon",
    component: _635fe0e3,
    name: "icon___nl"
  }, {
    path: "/inspiratie",
    component: _2542f4d8,
    name: "blog-category___nl"
  }, {
    path: "/login",
    component: _cad79e9c,
    name: "login___nl"
  }, {
    path: "/merk",
    component: _7c127f50,
    name: "brand___nl"
  }, {
    path: "/vestigingen",
    component: _69715966,
    name: "store-lister___nl"
  }, {
    path: "/wachtwoord-vergeten",
    component: _37296ece,
    name: "forgot-password___nl"
  }, {
    path: "/wishlist",
    component: _15468272,
    name: "wishlist___nl"
  }, {
    path: "/blocks/demo",
    component: _78ec3ad2,
    name: "blocks-demo___nl"
  }, {
    path: "/forgot-password/reset",
    component: _4028466a,
    name: "forgot-password-reset___nl"
  }, {
    path: "/klantenservice/faq",
    component: _41d65b9f,
    name: "faq___nl"
  }, {
    path: "/login/guest",
    component: _d4757a90,
    name: "login-guest___nl"
  }, {
    path: "/myaccount/resetpassword/redirect",
    component: _667a0590,
    name: "forgot-password-redirect___nl"
  }, {
    path: "/inspiratie/post/:slug?",
    component: _25daf69f,
    name: "blog-detail-slug___nl"
  }, {
    path: "/review/detail/:slug?",
    component: _f85863ae,
    name: "review-detail-slug___nl"
  }, {
    path: "/review/writing/:slug?",
    component: _ba15b9ec,
    name: "review-writing-slug___nl"
  }, {
    path: "/p/:slug?",
    component: _70ab1f54,
    name: "product-detail-slug___nl"
  }, {
    path: "/vestigingen/:slug?",
    component: _796659b8,
    name: "store-detail-slug___nl"
  }, {
    path: "/zoek/:slug?",
    component: _706bc466,
    name: "search-slug___nl"
  }, {
    path: "/inspiratie/*",
    component: _62d218be,
    name: "blog-category-all___nl"
  }, {
    path: "/tag/*",
    component: _0ce2f767,
    name: "blog-tag-all___nl"
  }, {
    path: "/m/*",
    component: _78772b8d,
    name: "brand-lister-all___nl"
  }, {
    path: "/producten/*",
    component: _7bd086a5,
    name: "product-lister-all___nl"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index___nl"
  }, {
    path: "/*",
    component: _2efaf336,
    name: "all___nl"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
